<div class="row">
  <div class="col-lg-12 col-md-12 main_img">
    <img loading="lazy" src="../../../assets/images/process white 2.jpg" />

    <!-- <a class="yellow_btn">Find out more</a>
        <a class="yellow_btn">Purchase</a> -->
  </div>

  <div class="col-md-12 faq">
    <div class="demo">
      <div class="accordion" id="accordionExample">
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button
                type="button"
                class="btn btn-link"
                data-toggle="collapse"
                data-target="#collapseOne"
              >
                Is MYVIP a better alternative to buying reviews to increase the
                local rank? <i class="fa fa-plus"></i>
              </button>
            </h2>
          </div>
          <div
            id="collapseOne"
            class="collapse"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div class="card-body">
              <p>
                MYVIP's automated feedback system allows you to get genuine
                feedback for your business which you can filter before allowing
                them to post to your online social accounts such as Google,
                Facebook, Trustpilot, Trip Advisor etc.
              </p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingTwo">
            <h2 class="mb-0">
              <button
                type="button"
                class="btn btn-link"
                data-toggle="collapse"
                data-target="#collapseTwo"
              >
                Buy reviews: Should You Really Do It? This Will Help You Decide!
                <i class="fa fa-plus"></i>
              </button>
            </h2>
          </div>
          <div
            id="collapseTwo"
            class="collapse"
            aria-labelledby="headingTwo"
            data-parent="#accordionExample"
          >
            <div class="card-body">
              <p>
                Yes and No. In fact MYVIP helps successful businesses do both at
                the same time. Organic growth is require for the long term while
                in the immediate we help boost reviews to a base number.
              </p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingThree">
            <h2 class="mb-0">
              <button
                type="button"
                class="btn btn-link collapsed"
                data-toggle="collapse"
                data-target="#collapseThree"
              >
                What features make MYVIP become the best review generation
                software? <i class="fa fa-plus"></i>
              </button>
            </h2>
          </div>
          <div
            id="collapseThree"
            class="collapse"
            aria-labelledby="headingThree"
            data-parent="#accordionExample"
          >
            <div class="card-body">
              <p>
                MYVIP's easily customizable features allow a user to leverage
                his strengths to get the feedback or reviews he requires. Full
                customization with a dedicated consultancy is provided for
                enterprise businesses which have multiple entities under them.
              </p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingFour">
            <h2 class="mb-0">
              <button
                type="button"
                class="btn btn-link collapsed"
                data-toggle="collapse"
                data-target="#collapseFour"
              >
                How does MYVIP help improve my visibility to Tourists?
                <i class="fa fa-plus"></i>
              </button>
            </h2>
          </div>
          <div
            id="collapseFour"
            class="collapse"
            aria-labelledby="headingFour"
            data-parent="#accordionExample"
          >
            <div class="card-body card-img">
              <img loading="lazy"
                src="../../../assets/images/new/Automated_Review_generator.jpeg"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingFive">
            <h2 class="mb-0">
              <button
                type="button"
                class="btn btn-link collapsed"
                data-toggle="collapse"
                data-target="#collapseFive"
              >
                What type of business does MYVIP benefit the most?
                <i class="fa fa-plus"></i>
              </button>
            </h2>
          </div>
          <div
            id="collapseFive"
            class="collapse"
            aria-labelledby="headingFive"
            data-parent="#accordionExample"
          >
            <div class="card-body card-img">
              <img loading="lazy" src="../../../assets/images/new/marketing.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
